import './ProductPlaceholder.css';

interface ProductPlaceholderProps {
  title: string;
  description?: string;
}

function ProductPlaceholder({ title, description }: ProductPlaceholderProps) {
  return (
    <main className="product-placeholder">
      <div className="product-placeholder__card">
        <h2>{title}</h2>
        <p>{description || '이 화면은 추후 구성됩니다.'}</p>
      </div>
    </main>
  );
}

export default ProductPlaceholder;
